<template>
  <el-dialog :title="title" 
    :close-on-click-modal="false" 
    :close-on-press-escape="false" 
    :visible.sync="isDialog" 
    :width="width" 
    :before-close="handleClose" 
    class="myDialog"
    :class="[isHeader ? 'isHeader' : '', bodyFill ? 'bodyFill' : '']"
    append-to-body
    :show-close="showClose"
  >
    <div v-if="isHeader">
      <slot name="header"></slot>
    </div>
    <div :style="bodyFill ? '' : 'overflow: hidden;'">
      <slot name="content"></slot>
    </div>

    <span slot="footer" class="dialog-footer" v-if="isFooter|| ($slots.footer && Array.isArray($slots.footer) && $slots.footer.length)">
      <!-- <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      <slot name="footer"></slot>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50%'
    },
    title: {
      type: String,
      default: '默认标题'
    },
    isFooter:{
      type: Boolean,
      default: false
    },
    isHeader:{
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    // 为 true 时，内容区占满容器，不出现底部滚动条
    bodyFill: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
  },
}
</script>

<style lang="scss" scoped>
.myDialog {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3%;
  .dialog-footer{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/.el-dialog{
    border-radius: 8px;
  }

  /deep/.el-dialog__header{
    // padding: 17px 40px;
    padding: 17px 20px;
    color: #2a3347;
    // border-radius: 8px 8px 0 0;
    // background-image: url('../../../assets/images/headDialog.png');
    // background-repeat: no-repeat;
    // background-position:center;
    // // background-size: 100% 100%;
    // background-size: cover;

    font-weight: bold;
    font-size: 18px;
    background: #f5f6f8;
    border-bottom: 1px solid #ddd;
  }
  /deep/.el-dialog__title{
    // color: #2a3347;
    // font-weight: bold;
    // font-size: 20px;
    // display: flex;
    // align-items: center;

    // &::before{
    //   content: '';
    //   display: block;
    //   width: 10px;
    //   height: 10px;
    //   border: 2px solid #0083ff;
    //   box-sizing: border-box;
    //   border-radius: 50%;
    //   margin-right: 8px;
    // }
  }
  /deep/.el-dialog__headerbtn{
    top: 17px;
    width: 24px;
    height: 24px;
    background-image: url('../../../assets/images/icon-close.png');
    background-repeat: no-repeat;
    background-position:center;
    background-size: 100% 100%;
  }
  /deep/.el-dialog__headerbtn .el-dialog__close{
    display: none;
  }
  /deep/.el-dialog__body {
    padding: 15px 20px;
    overflow: auto;
    max-height: 65vh;
  }
  &.bodyFill /deep/.el-dialog__body {
    max-height: none;
    overflow: visible;
  }
  /deep/.el-dialog__footer{
    padding: 10px 20px;
    // border-top: 1px solid #ddd;
    background: #f3f6f7;
    display: flex;
    // justify-content: flex-end;
    justify-content: center;
  }
}
.isHeader{
  /deep/.el-dialog__header{
    display: none!important;
  }
}
</style>